import { render, staticRenderFns } from "./Accelerator.vue?vue&type=template&id=1de73fac&scoped=true&"
import script from "./Accelerator.vue?vue&type=script&lang=js&"
export * from "./Accelerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de73fac",
  null
  
)

export default component.exports